export const EVENT_ID = {
  DAILY_EVENT: 34,
  WEEKLY_EVENT: 75,
  TOURNAMENT_EVENT: 150,
  BCS_EVENT: 149,
  MEMORY_MATCH_EVENT: 151,
  SPELLING_BEE_EVENT: 134,
  WORDLY_BANGLA_EVENT: 79,
  WORDLY_ENGLISH_EVENT: 67,
};

